export const kitConditionOptions = [
  { value: null, text: 'Selecione a Condição' },
  { value: '<=', text: 'Até' },
  { value: '>=', text: 'A partir de' },
  { value: '<', text: 'Menos de' },
  { value: '=', text: 'Igual a' },
  { value: '>', text: 'Mais de' },
];

export const regionalOptions = [
  { value: 'norteSul', text: 'Norte-Sul' },
  { value: 'nordeste', text: 'Nordeste' },
  { value: 'sudeste', text: 'Sudeste' },
];
